module.exports = __webpack_public_path__ + "a02e1e7f3ecd97431a5abacb79da1aa7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio1/08_MCA Selfless in the Bath Of Lava.mp3
// module id = 788
// module chunks = 0